// AuditLogService.js
import { endpoints, baseurl } from "../Utils/Constants";

export const getAuditLogs = async (token, year, signal) => {
    try {
        const url = year
            ? `${baseurl}${endpoints.GET_AUDIT_LOGS}?year=${year}`
            : baseurl + endpoints.GET_AUDIT_LOGS;
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "ngrok-skip-browser-warning": "true",
                "Authorization": `Bearer ${token}`
            },
            signal
        });
        return await response.json();
    } catch (error) {
        if (error?.name !== "AbortError") {
            console.error("Error fetching audit logs:", error);
        }
        throw error;
    }
}

export const getAudit100Logs = async (token, year, signal) => {
    try {
        const url = year
            ? `${baseurl}${endpoints.GET_AUDIT_100_LOGS}?year=${year}`
            : baseurl + endpoints.GET_AUDIT_100_LOGS;
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "ngrok-skip-browser-warning": "true",
                "Authorization": `Bearer ${token}`
            },
            signal
        });
        return await response.json();
    } catch (error) {
        if (error?.name !== "AbortError") {
            console.error("Error fetching first 100 audit logs:", error);
        }
        throw error;
    }
}

export const getAuditLogById = async (id, token) => {
    try {
        const response = await fetch(baseurl + endpoints.GET_AUDIT_BY_ID + id, {
            method: "GET",
            headers: {
                "ngrok-skip-browser-warning": "true",
                "Authorization": `Bearer ${token}`
            }
        });
        return await response.json();
    } catch (error) {
        console.error("Error fetching audit log by ID:", error);
        throw error;
    }
}
